// extracted by mini-css-extract-plugin
module.exports = {"projectList":"TopProjectsSectionView_projectList__2yfbe","empty":"TopProjectsSectionView_empty__ORmoq"};